import NavMenu from "../../../components/public/others/Navbar";
import Footer from "../../../components/public/others/Footer";
import Jecos from "../../../components/public/news/jecos/Jecos";

export default function JecosPage() {
  return (
    <>
      <NavMenu />
      <div className="GroupBottomCM">
        <Jecos />
        <Footer />
      </div>
    </>
  );
}
